import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantsCLA } from '../../../shared/constants-cla';
import {
  ListInstructorsOrTutorsDTO,
  InstructorOrTutorDTO,
  ListSelectDTO,
} from 'src/app/model/newModel';
import { AddUpdateInstructorOrTutorCommand } from 'src/app/model/command-model';
import {
  SelectCommand,
  GetUtenteCommand,
  AbilitaDisabilitaCommand,
  SearchInstructorsOrTutorsCommand,
} from '../../../model/command-model';

@Injectable({
  providedIn: 'root',
})
export class AUtenteService {
  constructor(private http: HttpClient) {}

  save(newUtente: AddUpdateInstructorOrTutorCommand) {
    return this.http.post<AddUpdateInstructorOrTutorCommand>(
      ConstantsCLA.CREA_UTENTE_URL,
      newUtente
    );
  }

  update(update: AddUpdateInstructorOrTutorCommand) {
    return this.http.post<AddUpdateInstructorOrTutorCommand>(
      ConstantsCLA.MODIFICA_UTENTE_URL,
      update
    );
  }

  selectGruppi() {
    const command = new SelectCommand();
    return this.http.post<ListSelectDTO>(
      ConstantsCLA.GRUPPO_COMBO_URL,
      command
    );
  }

  get(idInstructor: number) {
    const command = new GetUtenteCommand();
    command.id = idInstructor;
    command.withInfoGruppo = true;
    return this.http.post<InstructorOrTutorDTO>(
      ConstantsCLA.GET_UTENTE_URL,
      command
    );
  }

  abilitaDisabilita(id: number, isAbilita: boolean) {
    const command = new AbilitaDisabilitaCommand();
    command.id = id;
    command.active = isAbilita;
    return this.http.post<boolean>(
      ConstantsCLA.ABILITA_DISABILITA_URL,
      command
    );
  }

  search() {
    const command = new SearchInstructorsOrTutorsCommand();
    command.withInfoGruppo = true;
    return this.http.post<ListInstructorsOrTutorsDTO>(
      ConstantsCLA.UTENTI_SEARCH_URL,
      command
    );
  }
}
